import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Requests',
    icon: 'layout-outline',
    link: '/requests',
  },
  {
    title: 'Special Meals',
    icon: 'home-outline',
    link: '/special-meals',
  },
  {
    title: 'Buz Meals',
    icon: 'home-outline',
    children: [
      {
        title: 'Import Flight Menu',
        link: '/buz-meal/import',
      },
      {
        title: 'Flight Menu',
        link: '/buz-meal/flight-menu',
      },
      {
        title: 'BuzMeal Information',
        link: '/buz-meal/buz-meals',
      },
      {
        title: 'Order Meal',
        link: '/buz-meal/order',
      }
    ],
  },
  {
    title: 'Report',
    icon: 'layout-outline',
    link: '/reports',
    children: [
      {
        title: 'Report by request status',
        link: '/reports/report-request-status',
      },
      {
        title: 'Report sales',
        link: '/reports/report-sale',
      },
      {
        title: 'Report all booking BuzMeal',
        link: '/reports/report-booking-buz-meal',
      },
      {
        title: 'Report booking BuzMeal by Period',
        link: '/reports/report-booking-buz-meal-period',
      }
    ],
  },
  {
    title: 'Configurations',
    icon: 'layout-outline',
    children: [
      {
        title: 'Offices',
        link: '/configurations/offices',
      },
      {
        title: 'Users',
        link: '/configurations/users',
      },
      {
        title: 'Roles',
        link: '/configurations/roles',
      },
    ],
  },
];
